import { render, staticRenderFns } from "./CellLabor.vue?vue&type=template&id=54a4f551&scoped=true&"
import script from "./CellLabor.vue?vue&type=script&lang=js&"
export * from "./CellLabor.vue?vue&type=script&lang=js&"
import style0 from "./CellLabor.vue?vue&type=style&index=0&id=54a4f551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4f551",
  null
  
)

export default component.exports